/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getEntitlementsV1 } from '@modules/billing-api/v1/callers'
import type { QueryFunctionReturnType, QueryHookOptions } from '@modules/query/types'
import { queryClient } from '@modules/query'

import { defaultBillingOptions } from './constants'

const GET_ENTITLEMENTS_QUERY_KEY = 'getEntitlementsV1'

const useGetEntitlements = (organizationId: string | undefined, options?: QueryHookOptions) =>
  useQuery<QueryFunctionReturnType<typeof getEntitlementsV1>>(
    [GET_ENTITLEMENTS_QUERY_KEY, organizationId],
    () =>
      organizationId === undefined
        ? Promise.reject(false)
        : getEntitlementsV1({ pathParameters: { organization_id: organizationId } }),
    {
      ...defaultBillingOptions,
      ...options,
    },
  )

export const invalidateGetEntitlementsV1 = () =>
  queryClient.invalidateQueries({ queryKey: [GET_ENTITLEMENTS_QUERY_KEY] })

export default useGetEntitlements
